import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Constant } from '@shared/utilities/constant';
import { AppConfig } from '@shared/models/app-config.model';

import { MemberClientResponse, MemberIdentiiesResponse, SendEmailDto, TemplateResolutionRequestDto, TemplateResolutionResponseDto, 
    UnsubscribeActivitySearchDto, UnsubscribeActivitySearchResultDto, UnsubscribeGroupConfigDto, UnsubscribeGroupDto, 
    UnsubscribePreferencesDto } from './unsubscribe-dtos';

@Injectable()
export class UnsubscribeService {

    private headers: HttpHeaders;

    // service API urls
    private getEmailUnsubscribeGroupsForTemplateUrl: string = 'MemberManager/api/EmailUnsubscribeGroup/GetEmailUnsubscribeGroupsForTemplate/{templateId}';
    private getEmailUnsubscribeActivityUrl: string = 'MemberManager/api/EmailUnsubscribeActivity/GetAll?includeDeactived=true';
    private persistPreferencesUrl: string = 'MemberManager/api/EmailUnsubscribeActivity/PersistEmailAddressUnsubscribePreferences/{emailAddress}/{notificationKey}';
    private getEmailUnsubscribeGroupConfigsUrl: string = 'MemberManager/api/EmailUnsubscribeActivity/GetEmailUnsubscribeGroupConfigs';
    private resolveTemplateDefinitionUrl: string = 'api/TemplateDefinition/ResolveTemplate';
    private correspondenseServiceSendSingleEmailUrl: string = 'api/Email/SendSingleEmail'; 
    private getConfigValueUrl: string = 'MemberManager/api/Member/GetConfig/{key}'; 
    private getTemplateDefinitionUrl: string = 'api/TemplateDefinition/{id}/true';
    private getEmailSentSuccessStatusUrl: string = 'MemberManager/api/NotificationQueue/GetEmailSentSuccessStatus/{requestId}';
    private getMemberIdByEmailUrl: string = 'MemberManager/api/Member/{email}/DetailsByEmail';
    private getClientCodeByMemberIdUrl: string = 'MemberManager/api/Member/GetClientCodeByMemberId?MemberId={currentMemberId}';

    constructor(private _http: HttpClient, @Inject(Constant.appConfig) private _appConfig: AppConfig) {

        let userName: string = 'unsubscribe app';

        this.headers = new HttpHeaders()
            .set('UserName', userName)
            .set('RoleId', '1');
    }

    public getUnsubscribeGroupConfigs(): Observable<UnsubscribeGroupConfigDto> {

        let url = (this._appConfig.apiBaseUrl + this.getEmailUnsubscribeGroupConfigsUrl);

        return this._http.get<UnsubscribeGroupConfigDto>(url, { headers: this.headers });
    }

    public getUnsubscribeGroupsForTemplate(templateId: string): Observable<UnsubscribeGroupDto[]> {

        let url = (this._appConfig.apiBaseUrl + this.getEmailUnsubscribeGroupsForTemplateUrl)
            .replace('{templateId}', String(templateId));

        return this._http.get<UnsubscribeGroupDto[]>(url, {headers: this.headers});
    }

    public getUnsubscribeActivityForEmailAddress(searchDto: UnsubscribeActivitySearchDto): Observable<UnsubscribeActivitySearchResultDto> {

        let url = (this._appConfig.apiBaseUrl + this.getEmailUnsubscribeActivityUrl)
            .replace('{includeDeleted}', 'true');
        
        return this._http.post<UnsubscribeActivitySearchResultDto>(url, searchDto, {headers: this.headers});
    }

    public persistPreferences(unsubscribePreferencesDto: UnsubscribePreferencesDto, notificationKey: string): Observable<string> {

        let url = this._appConfig.apiBaseUrl + this.persistPreferencesUrl
            .replace('{emailAddress}', unsubscribePreferencesDto.emailAddress)
            .replace('{notificationKey}', notificationKey);

        return this._http.post<string>(url, unsubscribePreferencesDto, { headers: this.headers });
    }

    public getResolvedTemplate(requestModel: TemplateResolutionRequestDto): Observable<TemplateResolutionResponseDto> {

        let url: string = this._appConfig.templateServiceApiBaseUrl  + this.resolveTemplateDefinitionUrl;

        return this._http.post<TemplateResolutionResponseDto>(url, requestModel, {headers: this.headers});
    }

    public sendEmail(emailRequestModel: SendEmailDto): Observable<string> {

        let url: string = this._appConfig.correspondenceServiceApiBaseUrl + this.correspondenseServiceSendSingleEmailUrl;

        return this._http.post<string>(url, emailRequestModel, {headers: this.headers});
    }

    public getConfig(key: string): Observable<string> {

        let url = this._appConfig.apiBaseUrl + this.getConfigValueUrl.replace('{key}', String(key));
    
        return this._http.get(url, { headers: this.headers, responseType: 'text' });
    }

    public getTemplate(templateId: string): Observable<any> {

        let url = (this._appConfig.templateServiceApiBaseUrl + this.getTemplateDefinitionUrl)
            .replace('{id}', templateId);

        return this._http.get<any>(url, {headers: this.headers});
    }

    public getEmailSentSuccessStatus(requestId: string): Observable<boolean> {

        let url = (this._appConfig.apiBaseUrl + this.getEmailSentSuccessStatusUrl)
            .replace('{requestId}', requestId);

        return this._http.get<boolean>(url, {headers: this.headers});
    }

    public getMemberIdByEmail(emailId: string): Observable<MemberIdentiiesResponse> {

        let url = (this._appConfig.apiBaseUrl + this.getMemberIdByEmailUrl)
            .replace('{email}', emailId);

        return this._http.get<MemberIdentiiesResponse>(url, {headers: this.headers});
    }

    public getClientCodeByMemberId(memberId: string): Observable<MemberClientResponse> {

        let url = (this._appConfig.apiBaseUrl + this.getClientCodeByMemberIdUrl)
            .replace('{currentMemberId}', memberId);

        return this._http.get<MemberClientResponse>(url, {headers: this.headers});
    }
}
